module.exports = __webpack_public_path__ + "img/Mack.a845d5ef.jpg";